import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import type { UseQueryResult } from "react-query";
import { useCommunityMembersList } from "@circle-react/hooks/useCommunityMembersList";
import type { ContactsListResponse } from "./types";

type CommunityMembersListContextValue = UseQueryResult<
  ContactsListResponse,
  Error
> | null;

export const CommunityMembersListContext =
  createContext<CommunityMembersListContextValue>(null);
CommunityMembersListContext.displayName = "CommunityMembersListContext";
export const useCommunityMembersListContext = () => {
  const communityMembersListContext = useContext(CommunityMembersListContext);

  console.assert(
    communityMembersListContext,
    "useCommunityMembersListContext is being used outside context provider.",
  );
  return communityMembersListContext;
};

interface CommunityMembersListProviderProps {
  children: ReactNode;
  ids?: number[];
}

export const CommunityMembersListProvider = ({
  ids,
  children,
}: CommunityMembersListProviderProps) => {
  const reactQueryProps = useCommunityMembersList({
    ids: [...new Set(ids ?? [])],
    withDeleted: true,
    enabled: !!ids?.length,
  });

  return (
    <CommunityMembersListContext.Provider value={reactQueryProps}>
      {children}
    </CommunityMembersListContext.Provider>
  );
};
